import { BusinessOutlined, LockOutlined, SyncOutlined } from '@mui/icons-material';
import { firmScimConfigurationUrl, firmSettingsUrl, firmSingleSignOnUrl } from 'common/config/urls';
import { PrimaryNavigationMenu, PrimaryNavigationMenuItem } from 'components/ui';
import { FIRM_PRIMARY_NAVIGATION_TEST_IDS } from 'layouts/FirmBaseLayout/PrimaryNavigation/PrimaryNavigation.testIds';
import type { FirmSettingsMenuProps } from './FirmSettingsMenu.props';

const FirmSettingsMenu = ({ anchorEl, firmSlug, onClose, onNavigate, zoomLevel }: FirmSettingsMenuProps) => (
  <PrimaryNavigationMenu
    id={FIRM_PRIMARY_NAVIGATION_TEST_IDS.firmSettingsMenu}
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    data-testid={FIRM_PRIMARY_NAVIGATION_TEST_IDS.firmSettingsMenu}
    menuMinWidth={200}
    zoomLevel={zoomLevel}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}>

    <PrimaryNavigationMenuItem
      icon={<BusinessOutlined fontSize="inherit" />}
      onClick={() => onNavigate(firmSettingsUrl(firmSlug))}
      data-testid={FIRM_PRIMARY_NAVIGATION_TEST_IDS.firmProfile}>
      Firm Profile
    </PrimaryNavigationMenuItem>
    <PrimaryNavigationMenuItem
      icon={<LockOutlined fontSize="inherit" />}
      onClick={() => onNavigate(firmSingleSignOnUrl(firmSlug))}
      data-testid={FIRM_PRIMARY_NAVIGATION_TEST_IDS.sso}>
      Single Sign-On
    </PrimaryNavigationMenuItem>
    <PrimaryNavigationMenuItem
      icon={<SyncOutlined fontSize="inherit" />}
      onClick={() => onNavigate(firmScimConfigurationUrl(firmSlug))}
      data-testid={FIRM_PRIMARY_NAVIGATION_TEST_IDS.scim}>
      SCIM
    </PrimaryNavigationMenuItem>
  </PrimaryNavigationMenu>
);

export default FirmSettingsMenu;
